export default __webpack_public_path__ + "img/beneficios-bg-card-4.d54e003a.png";